export enum PatientBillingRoutes {
  items = "Items",
  vendor = "Vendor",
}

export const patientBillingKeys = Object.keys(PatientBillingRoutes);

export type PatientBillingKey = keyof typeof PatientBillingRoutes;
